import React from 'react';
import { sanitizeHTML } from '../../utils/htmlSanitizer';
import './RichTextDisplay.css';

/**
 * RichTextDisplay - Safely renders HTML content with sanitization
 *
 * @param {Object} props
 * @param {string} props.content - HTML or plain text content
 * @param {string} props.className - Additional CSS classes
 */
function RichTextDisplay({ content, className = '' }) {
  if (!content) {
    return <p className="rich-text-display empty">No description</p>;
  }

  // Sanitize HTML content
  const sanitized = sanitizeHTML(content);

  // Check if content is plain text (no HTML tags)
  const isPlainText = !content.includes('<');

  // Wrap plain text in paragraph
  const displayContent = isPlainText ? `<p>${sanitized}</p>` : sanitized;

  return (
    <div
      className={`rich-text-display ${className}`}
      dangerouslySetInnerHTML={{ __html: displayContent }}
    />
  );
}

export default RichTextDisplay;
